import { useEffect } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { updateFormationArea } from "../../services/school/formationArea";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { FormationAreaType } from "../../types/FormationAreaType";
import { FormationAreaFormValidation } from "./FormationAreaFormValidation";
import { resetFormationAreaData } from "../../redux/slices/school/formationArea";
import { useGetKnowledgeDomainsQuery } from "../../hooks/useGetKnowledgeDomainsQuery";
import { useGetKnowledgeSubDomainsQuery } from "../../hooks/useGetKnowledgeSubDomainsQuery";
import { isEmpty } from "lodash";
import SelectComponent from "../../components/inputs/Select/SelectComponent";

export const UpdateFormationArea = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const formationAreaData = useAppSelector((state) => state.formationArea);
    const mutation = useMutation({ mutationFn: updateFormationArea, mutationKey: "updateFormationArea" });
    const { control, handleSubmit, formState: { errors }, reset, getValues, resetField, setValue } = useForm<FormationAreaType>({
        resolver: yupResolver(FormationAreaFormValidation),
        defaultValues: formationAreaData,
        mode: "onBlur",
    });
    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Área de Formação atualizada com sucesso!");
            navigate(routes.formationAreas);
            dispatch(resetFormationAreaData());
        } catch (err) {
            toast.error("Erro ao atualizar Área de Formação");
        }
    });
    const { data: domains, isLoading: isLoadingDomains, isError: errorDomains } = useGetKnowledgeDomainsQuery({ PageNumber: 1, PageSize: 400 });
    
        const { data: subDomains, isLoading: isLoadingSubDomains, isError: errorSubDomains, refetch: refreshSubDomains } = useGetKnowledgeSubDomainsQuery(
            { PageNumber: 1, PageSize: 400, DomainId: getValues('idKnowledgeDomain') },
            { enabled: !!getValues('idKnowledgeDomain') }
        );
    
        const handleKnowledgeDomainChange = (id: string) => {
            setValue('idKnowledgeDomain', id);
            if (isEmpty(id)) {
                resetField('idKnowledgeSubDomain');
                return;
            }
            refreshSubDomains();
        };
    

    const handleBack = () => {
        dispatch(resetFormationAreaData());
        navigate(routes.formationAreas);
    };
    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent 
                        name="description" 
                        label="Nome" 
                        control={control} 
                        errors={errors} 
                        required={true} 
                    />
                    <TextFieldComponent name="code" label="Código" control={control} errors={errors} required={true} />
                     <Flex gap='4'>
                        <SelectComponent
                            name="idKnowledgeDomain"
                            label="Domínio de Conhecimento"
                            control={control}
                            errors={errors}
                            style={{ width: '100%' }}
                            options={domains?.items.map(domain => ({
                                value: domain.id ?? "",
                                label: domain.description ?? ""
                            }))}
                            itemsLoading={isLoadingDomains}
                            itemsError={errorDomains}
                            onSelect={handleKnowledgeDomainChange}
                            required={true}
                        />
                        <SelectComponent
                            name="idKnowledgeSubDomain"
                            label="SubDomínio de Conhecimento"
                            control={control}
                            errors={errors}
                            style={{ width: '100%' }}
                            options={subDomains?.items.map(subDomain => ({
                                value: subDomain.id ?? "",
                                label: subDomain.description ?? ""
                            }))}
                            itemsLoading={isLoadingSubDomains}
                            itemsError={errorSubDomains}
                            required={true}
                        />
                    </Flex>
                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button color="red" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading} variant="surface">
                            {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                            Atualizar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
